export default "__VITE_ASSET__bbf86310__"